window.globalHelpersModule.directive "creationExpired", 
['$rootScope', '$log', '$timeout', '$filter', '$state', 'AuthService',
($rootScope, $log, $timeout, $filter, $state, AuthService) ->
  restrict: "E"
  scope:
    feedItem: "="
  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/feed-items/creation_expired/creation_expired-directive-template.html'
]